import { render, staticRenderFns } from "./AntTables.vue?vue&type=template&id=4e550956&scoped=true"
import script from "./AntTables.vue?vue&type=script&lang=js"
export * from "./AntTables.vue?vue&type=script&lang=js"
import style0 from "./AntTables.vue?vue&type=style&index=0&id=4e550956&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e550956",
  null
  
)

export default component.exports